import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const reviewsModule = defineModule({
  name: "reviews",
  label: "Ratings & reviews",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
    "logistics",
    "cart",
    "payments",
    "payouts",
    "orders",
  ],
  i18n: { en },
  // Admin step 11 (P5-06): moderation. The product page shows the reviews in the storefront (P6-05).
  admin: {
    routes: [
      {
        path: "reviews",
        permission: "reviews.view_review",
        page: () => import("./admin/ReviewsPage"),
      },
    ],
    nav: [
      {
        id: "reviews",
        group: "catalog",
        label: "reviews:nav.reviews",
        icon: "eye",
        to: "/reviews",
        permission: "reviews.view_review",
        order: 8,
      },
    ],
  },
  vendor: { routes: [], nav: [] },
});
